export interface CustomError {
  status: number
  message: string
  stack: string
  name: string
}

export interface ErrorProps {
  error: CustomError
}

export const DevelopmentEnvComponent = ({ error }: ErrorProps) => {
  const developmentEnv = process.env.NODE_ENV === 'development'
  if (!developmentEnv) {
    return null
  }

  // eslint-disable-next-line no-console
  console.error(error)

  return (
    <div style={{ textAlign: 'center' }}>
      <p>{error?.name}</p>
      <p>{error?.message}</p>
      <pre>{error?.stack}</pre>
    </div>
  )
}
